import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(read),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(write),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(handleReconnect),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(handleAuthenticate),
    _marked5 = /*#__PURE__*/_regeneratorRuntime.mark(handleIO),
    _marked6 = /*#__PURE__*/_regeneratorRuntime.mark(watchEvents);

import { actionChannel, all, call, fork, put, select, take, takeEvery } from 'redux-saga/effects';
import { eventChannel } from 'redux-saga';
import jwtDecode from 'jwt-decode';
import createWebSocketConnection from './socketConnection';
import { ACKNOWLEDGE, ANNOUNCEMENT, AUTHENTICATE, CREATED, DELETE_SUCCESS, DELETED, GET_LIST_SUCCESS, GET_ONE, GET_ONE_SUCCESS, JOIN, JOIN_ROOM, LEAVE, LEAVE_ROOM, SEND_MESSAGE, UPDATED, USERS_LIST, WS_AUTHENTICATE_FAILURE, WS_AUTHENTICATE_SUCCESS, WS_CONNECT, WS_CONNECT_SUCCESS, WS_FAILURE, WS_LOGOUT, WS_RECONNECT, WS_RECONNECTING } from '../actions/constants';
import websocketActions from '../actions/websocket';
var WS_AUTHENTICATE = "@@WS/".concat(AUTHENTICATE);
var WS_JOIN_ROOM = "@@WS/".concat(JOIN_ROOM);
var WS_LEAVE_ROOM = "@@WS/".concat(LEAVE_ROOM);
var WS_SEND_MESSAGE = "@@WS/".concat(SEND_MESSAGE);
var WS_MESSAGE = '@@WS/MESSAGE';

function subscribe(socket) {
  return eventChannel(function (emit) {
    socket.on('reconnecting', function () {
      emit({
        type: WS_RECONNECTING
      });
    });
    socket.on('reconnect', function () {
      emit({
        type: WS_RECONNECT
      });
    });
    socket.on('message', function (message) {
      emit({
        type: WS_MESSAGE,
        message: message
      });
    });
    return function () {};
  });
}

function read(socket) {
  var channel, action;
  return _regeneratorRuntime.wrap(function read$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _context.next = 2;
        return call(subscribe, socket);

      case 2:
        channel = _context.sent;

      case 3:
        if (!true) {
          _context.next = 11;
          break;
        }

        _context.next = 6;
        return take(channel);

      case 6:
        action = _context.sent;
        _context.next = 9;
        return put(action);

      case 9:
        _context.next = 3;
        break;

      case 11:
      case "end":
        return _context.stop();
    }
  }, _marked);
}

function write(socket) {
  var _yield$take2, type, payload, _ref2, room, body, _ref$options2, options, token, _ref4, exp;

  return _regeneratorRuntime.wrap(function write$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        if (!true) {
          _context2.next = 37;
          break;
        }

        _context2.next = 3;
        return take([WS_AUTHENTICATE, WS_JOIN_ROOM, WS_LEAVE_ROOM, WS_SEND_MESSAGE, WS_LOGOUT]);

      case 3:
        _yield$take2 = _context2.sent;
        type = _yield$take2.type;
        payload = _yield$take2.payload;
        _ref2 = payload || {}, room = _ref2.room, body = _ref2.body, _ref$options2 = _ref2.options, options = _ref$options2 === void 0 ? {} : _ref$options2;
        _context2.next = 9;
        return select(function (state) {
          var _state$authentication, _state$users;

          return ((_state$authentication = state.authentication) === null || _state$authentication === void 0 || (_state$authentication = _state$authentication.item) === null || _state$authentication === void 0 ? void 0 : _state$authentication.token) || ((_state$users = state.users) === null || _state$users === void 0 || (_state$users = _state$users.item) === null || _state$users === void 0 ? void 0 : _state$users.token);
        });

      case 9:
        token = _context2.sent;

        if (!token) {
          _context2.next = 16;
          break;
        }

        _ref4 = jwtDecode(token) || {}, exp = _ref4.exp;

        if (!(!token || exp && exp * 1000 <= +new Date())) {
          _context2.next = 16;
          break;
        }

        _context2.next = 15;
        return put({
          type: WS_FAILURE,
          payload: {
            error: 'Token expired'
          }
        });

      case 15:
        return _context2.abrupt("continue", 0);

      case 16:
        _context2.prev = 16;
        _context2.t0 = type;
        _context2.next = _context2.t0 === WS_AUTHENTICATE ? 20 : _context2.t0 === WS_JOIN_ROOM ? 22 : _context2.t0 === WS_LEAVE_ROOM ? 24 : _context2.t0 === WS_LOGOUT ? 26 : _context2.t0 === WS_SEND_MESSAGE ? 28 : 28;
        break;

      case 20:
        socket.emit('authenticate', {
          token: token,
          type: 'TOKEN'
        });
        return _context2.abrupt("break", 29);

      case 22:
        socket.emit('join', room, options);
        return _context2.abrupt("break", 29);

      case 24:
        socket.emit('leave', room);
        return _context2.abrupt("break", 29);

      case 26:
        socket.emit('logout');
        return _context2.abrupt("break", 29);

      case 28:
        socket.emit('message', {
          room: room,
          body: body
        });

      case 29:
        _context2.next = 35;
        break;

      case 31:
        _context2.prev = 31;
        _context2.t1 = _context2["catch"](16);
        _context2.next = 35;
        return put({
          type: WS_FAILURE
        });

      case 35:
        _context2.next = 0;
        break;

      case 37:
      case "end":
        return _context2.stop();
    }
  }, _marked2, null, [[16, 31]]);
}

function handleReconnect() {
  var websocket, i, room;
  return _regeneratorRuntime.wrap(function handleReconnect$(_context3) {
    while (1) switch (_context3.prev = _context3.next) {
      case 0:
        _context3.next = 2;
        return take([WS_RECONNECT]);

      case 2:
        if (!_context3.sent) {
          _context3.next = 21;
          break;
        }

        _context3.next = 5;
        return put(websocketActions.reconnect());

      case 5:
        _context3.next = 7;
        return select(function (state) {
          return state.websocket;
        });

      case 7:
        websocket = _context3.sent;

        if (!(websocket.rooms.length > 0)) {
          _context3.next = 11;
          break;
        }

        _context3.next = 11;
        return put(websocketActions.authenticate());

      case 11:
        i = 0;

      case 12:
        if (!(i < websocket.rooms.length)) {
          _context3.next = 19;
          break;
        }

        room = websocket.rooms[i].room;
        _context3.next = 16;
        return put(websocketActions.join(room));

      case 16:
        i++;
        _context3.next = 12;
        break;

      case 19:
        _context3.next = 0;
        break;

      case 21:
      case "end":
        return _context3.stop();
    }
  }, _marked3);
}

function handleAuthenticate() {
  var _yield$select, connected;

  return _regeneratorRuntime.wrap(function handleAuthenticate$(_context4) {
    while (1) switch (_context4.prev = _context4.next) {
      case 0:
        _context4.next = 2;
        return select(function (_ref5) {
          var websocket = _ref5.websocket;
          return websocket;
        });

      case 2:
        _yield$select = _context4.sent;
        connected = _yield$select.connected;

        if (connected) {
          _context4.next = 7;
          break;
        }

        _context4.next = 7;
        return take(WS_CONNECT_SUCCESS);

      case 7:
        _context4.next = 9;
        return put({
          type: WS_AUTHENTICATE
        });

      case 9:
      case "end":
        return _context4.stop();
    }
  }, _marked4);
}

function handleIO(socket) {
  return _regeneratorRuntime.wrap(function handleIO$(_context5) {
    while (1) switch (_context5.prev = _context5.next) {
      case 0:
        _context5.next = 2;
        return fork(read, socket);

      case 2:
        _context5.next = 4;
        return fork(write, socket);

      case 4:
        _context5.next = 6;
        return fork(handleReconnect);

      case 6:
      case "end":
        return _context5.stop();
    }
  }, _marked5);
}

var socket;

var createFlow = function createFlow(websocketUri) {
  return /*#__PURE__*/_regeneratorRuntime.mark(function flow() {
    var _yield$take4, _yield$take3$payload2, clientType, applicationType, params;

    return _regeneratorRuntime.wrap(function flow$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          if (!true) {
            _context6.next = 19;
            break;
          }

          _context6.next = 3;
          return take(WS_CONNECT);

        case 3:
          _yield$take4 = _context6.sent;
          _yield$take3$payload2 = _yield$take4.payload;
          clientType = _yield$take3$payload2.clientType;
          applicationType = _yield$take3$payload2.applicationType;
          params = _yield$take3$payload2.params;

          if (socket) {
            _context6.next = 17;
            break;
          }

          _context6.next = 11;
          return call(createWebSocketConnection, clientType, websocketUri, applicationType, params);

        case 11:
          socket = _context6.sent;
          // eslint-disable-next-line @typescript-eslint/no-use-before-define
          dispatchWebsocketConnected(true);
          _context6.next = 15;
          return put({
            type: WS_CONNECT_SUCCESS
          });

        case 15:
          _context6.next = 17;
          return fork(handleIO, socket);

        case 17:
          _context6.next = 0;
          break;

        case 19:
        case "end":
          return _context6.stop();
      }
    }, flow);
  });
};

function handleEvent(_ref6) {
  var type = _ref6.type,
      payload = _ref6.payload;
  return /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _yield$select2, authenticated, dispatchedType;

    return _regeneratorRuntime.wrap(function _callee$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return select(function (_ref7) {
            var websocket = _ref7.websocket;
            return websocket;
          });

        case 2:
          _yield$select2 = _context7.sent;
          authenticated = _yield$select2.authenticated;

          if (authenticated) {
            _context7.next = 7;
            break;
          }

          _context7.next = 7;
          return take(WS_AUTHENTICATE_SUCCESS);

        case 7:
          _context7.t0 = type;
          _context7.next = _context7.t0 === JOIN_ROOM ? 10 : _context7.t0 === LEAVE_ROOM ? 12 : _context7.t0 === SEND_MESSAGE ? 14 : 14;
          break;

        case 10:
          dispatchedType = WS_JOIN_ROOM;
          return _context7.abrupt("break", 16);

        case 12:
          dispatchedType = WS_LEAVE_ROOM;
          return _context7.abrupt("break", 16);

        case 14:
          dispatchedType = WS_SEND_MESSAGE;
          return _context7.abrupt("break", 16);

        case 16:
          _context7.next = 18;
          return put({
            type: dispatchedType,
            payload: payload
          });

        case 18:
        case "end":
          return _context7.stop();
      }
    }, _callee);
  })();
}

function watchEvents() {
  var requestChan, _yield$take6, type, payload;

  return _regeneratorRuntime.wrap(function watchEvents$(_context8) {
    while (1) switch (_context8.prev = _context8.next) {
      case 0:
        _context8.next = 2;
        return actionChannel([JOIN_ROOM, LEAVE_ROOM, SEND_MESSAGE]);

      case 2:
        requestChan = _context8.sent;

      case 3:
        if (!true) {
          _context8.next = 13;
          break;
        }

        _context8.next = 6;
        return take(requestChan);

      case 6:
        _yield$take6 = _context8.sent;
        type = _yield$take6.type;
        payload = _yield$take6.payload;
        _context8.next = 11;
        return call(handleEvent, {
          type: type,
          payload: payload
        });

      case 11:
        _context8.next = 3;
        break;

      case 13:
      case "end":
        return _context8.stop();
    }
  }, _marked6);
}

function onWSMessage(mappings, options) {
  var _options$extendAction = options.extendAction,
      extendAction = _options$extendAction === void 0 ? function (action) {
    return action;
  } : _options$extendAction;
  return function wsMessageHandler() {
    var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref8$message = _ref8.message,
        messageParameter = _ref8$message === void 0 ? {} : _ref8$message;

    return /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _mappings$resource, _mappings$resource2, _mappings$resource3, _mappings$resource11, _mappings$resource16;

      var resource, action, _messageParameter$pay, payload, message, store, _mappings$resource12, actionToPut, _mappings$resource4, _mappings$resource5, _mappings$resource6, _mappings$resource7, _mappings$resource8, _mappings$resource9, _mappings$resource10, defaultGetId, getId, chunkId, _mappings$resource13, _mappings$resource14, _mappings$resource15, extendedAction, _mappings$resource17;

      return _regeneratorRuntime.wrap(function _callee2$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            resource = messageParameter.resource, action = messageParameter.action, _messageParameter$pay = messageParameter.payload, payload = _messageParameter$pay === void 0 ? {} : _messageParameter$pay, message = messageParameter.message;
            _context9.next = 3;
            return select(function (state) {
              return state;
            });

          case 3:
            store = _context9.sent;
            _context9.prev = 4;
            _context9.t0 = action;
            _context9.next = _context9.t0 === ANNOUNCEMENT ? 8 : _context9.t0 === AUTHENTICATE ? 10 : _context9.t0 === JOIN ? 12 : _context9.t0 === USERS_LIST ? 14 : _context9.t0 === LEAVE ? 16 : _context9.t0 === DELETED ? 16 : _context9.t0 === UPDATED ? 18 : _context9.t0 === CREATED ? 18 : _context9.t0 === ACKNOWLEDGE ? 23 : 25;
            break;

          case 8:
            actionToPut = {
              type: ANNOUNCEMENT,
              payload: payload
            };
            return _context9.abrupt("break", 27);

          case 10:
            actionToPut = {
              type: payload !== null && payload !== void 0 && payload.isAuthenticated ? WS_AUTHENTICATE_SUCCESS : WS_AUTHENTICATE_FAILURE
            };
            return _context9.abrupt("break", 27);

          case 12:
            actionToPut = {
              type: GET_ONE_SUCCESS,
              resource: mappings === null || mappings === void 0 || (_mappings$resource = mappings[resource]) === null || _mappings$resource === void 0 ? void 0 : _mappings$resource.resource,
              payload: payload,
              target: 'list'
            };
            return _context9.abrupt("break", 27);

          case 14:
            actionToPut = {
              type: GET_LIST_SUCCESS,
              resource: mappings === null || mappings === void 0 || (_mappings$resource2 = mappings[resource]) === null || _mappings$resource2 === void 0 ? void 0 : _mappings$resource2.resource,
              payload: payload,
              isUnique: true
            };
            return _context9.abrupt("break", 27);

          case 16:
            actionToPut = {
              type: DELETE_SUCCESS,
              resource: mappings === null || mappings === void 0 || (_mappings$resource3 = mappings[resource]) === null || _mappings$resource3 === void 0 ? void 0 : _mappings$resource3.resource,
              payload: {
                id: payload === null || payload === void 0 ? void 0 : payload.id
              },
              query: {
                params: payload
              }
            };
            return _context9.abrupt("break", 27);

          case 18:
            defaultGetId = function defaultGetId(e) {
              return e === null || e === void 0 ? void 0 : e.id;
            };

            getId = typeof (mappings === null || mappings === void 0 || (_mappings$resource4 = mappings[resource]) === null || _mappings$resource4 === void 0 ? void 0 : _mappings$resource4.getId) === 'function' ? mappings === null || mappings === void 0 || (_mappings$resource5 = mappings[resource]) === null || _mappings$resource5 === void 0 ? void 0 : _mappings$resource5.getId : defaultGetId;
            chunkId = getId(payload);
            actionToPut = {
              type: GET_ONE,
              resource: mappings === null || mappings === void 0 || (_mappings$resource6 = mappings[resource]) === null || _mappings$resource6 === void 0 ? void 0 : _mappings$resource6.resource,
              chunkUrlResource: (mappings === null || mappings === void 0 || (_mappings$resource7 = mappings[resource]) === null || _mappings$resource7 === void 0 ? void 0 : _mappings$resource7.chunkUrlResource) || (mappings === null || mappings === void 0 || (_mappings$resource8 = mappings[resource]) === null || _mappings$resource8 === void 0 ? void 0 : _mappings$resource8.resource),
              chunkId: chunkId,
              chunkResource: mappings === null || mappings === void 0 || (_mappings$resource9 = mappings[resource]) === null || _mappings$resource9 === void 0 ? void 0 : _mappings$resource9.chunkResource,
              getId: getId,
              originalAction: action,
              target: 'list',
              payload: {
                id: chunkId || (payload === null || payload === void 0 ? void 0 : payload.id),
                params: mappings === null || mappings === void 0 || (_mappings$resource10 = mappings[resource]) === null || _mappings$resource10 === void 0 ? void 0 : _mappings$resource10.params
              }
            };
            return _context9.abrupt("break", 27);

          case 23:
            actionToPut = {
              type: ACKNOWLEDGE,
              resource: mappings === null || mappings === void 0 || (_mappings$resource11 = mappings[resource]) === null || _mappings$resource11 === void 0 ? void 0 : _mappings$resource11.resource,
              payload: payload
            };
            return _context9.abrupt("break", 27);

          case 25:
            if (Object.prototype.toString.call(message) === '[object Object]' && message !== null && message !== void 0 && message.type) {
              actionToPut = message;
            }

            return _context9.abrupt("break", 27);

          case 27:
            if (!(resource && mappings !== null && mappings !== void 0 && (_mappings$resource12 = mappings[resource]) !== null && _mappings$resource12 !== void 0 && _mappings$resource12.createCustomAction)) {
              _context9.next = 32;
              break;
            }

            if (!(mappings !== null && mappings !== void 0 && (_mappings$resource13 = mappings[resource]) !== null && _mappings$resource13 !== void 0 && _mappings$resource13.doNotOverrideCoreBehaviourForCustomAction && actionToPut)) {
              _context9.next = 31;
              break;
            }

            _context9.next = 31;
            return put(extendAction(actionToPut));

          case 31:
            actionToPut = mappings === null || mappings === void 0 || (_mappings$resource14 = mappings[resource]) === null || _mappings$resource14 === void 0 ? void 0 : _mappings$resource14.createCustomAction(messageParameter, actionToPut);

          case 32:
            if (!actionToPut) {
              _context9.next = 36;
              break;
            }

            extendedAction = extendAction(_objectSpread(_objectSpread({}, actionToPut), (mappings === null || mappings === void 0 || (_mappings$resource15 = mappings[resource]) === null || _mappings$resource15 === void 0 || (_mappings$resource15 = _mappings$resource15.options) === null || _mappings$resource15 === void 0 ? void 0 : _mappings$resource15[action]) || {}), store);
            _context9.next = 36;
            return put(extendedAction);

          case 36:
            _context9.next = 41;
            break;

          case 38:
            _context9.prev = 38;
            _context9.t1 = _context9["catch"](4);
            console.warn('WS for resource: ', resource, 'error: ', _context9.t1);

          case 41:
            if (resource && (!(mappings !== null && mappings !== void 0 && mappings[resource]) || !(mappings !== null && mappings !== void 0 && (_mappings$resource16 = mappings[resource]) !== null && _mappings$resource16 !== void 0 && _mappings$resource16.resource))) {
              console.warn('WS resource: ', resource, 'mappings?.[resource]?.resource: ', mappings === null || mappings === void 0 || (_mappings$resource17 = mappings[resource]) === null || _mappings$resource17 === void 0 ? void 0 : _mappings$resource17.resource);
            }

          case 42:
          case "end":
            return _context9.stop();
        }
      }, _callee2, null, [[4, 38]]);
    })();
  };
}

export default (function (websocketUri) {
  var mappings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return /*#__PURE__*/_regeneratorRuntime.mark(function wsSaga() {
    return _regeneratorRuntime.wrap(function wsSaga$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return all([fork(watchEvents), fork(createFlow(websocketUri)), takeEvery(WS_MESSAGE, onWSMessage(mappings, options)), takeEvery(AUTHENTICATE, handleAuthenticate)]);

        case 2:
        case "end":
          return _context10.stop();
      }
    }, wsSaga);
  });
});
/**
 * This part is ONLY to safely expose the Websocket connection to react-query
 * - we need to expose some event so that react can "react" to the connection being available
 * - we MUST NOT pass the socket connection via the event, because it could be sniffed via code injection caused by XSS
 */

var WEBSOCKET_CONNECTED_EVENT = 'websocket:connected';
/**
 * Subscribe to this callback which will fire when the websocket connection is available
 * - To safely access the connection, use `getActiveWebsocket` (we don't want to expose it publicly on the event).
 * @param cb
 * @returns
 */

export function onWebsocketConnected(cb) {
  if (typeof window === 'undefined') return;
  window.addEventListener(WEBSOCKET_CONNECTED_EVENT, cb);
  return function cleanup() {
    if (typeof window === 'undefined') return;
    window.removeEventListener(WEBSOCKET_CONNECTED_EVENT, cb);
  };
}

function dispatchWebsocketConnected(connected) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(WEBSOCKET_CONNECTED_EVENT, {
    detail: {
      connected: connected
    }
  }));
}
/**
 * Retrieve the websocket connection (once the callback of `onWebsocketConnected` fired)
 */


export function getActiveWebsocket() {
  if (typeof window === 'undefined') {
    return;
  }

  return socket;
}
//# sourceMappingURL=ws.js.map